import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const HubWeatherRBAC = {
  pageID: '737d2e589a31b0d048018494c01db9ed',
  elementID: {
    ViewPage: '4b52afd03bcf963a31845f7240915323',
    UpdateStatus: '95c368cc855b0fe81e549908b994f3b8',
  },
} as const

export const useHubWeatherRBACPage = createUseRBAC(HubWeatherRBAC.elementID)

export type UseHubWeatherRBACPageType = ReturnType<typeof useHubWeatherRBACPage>
